<div class="modal-header">
  <h4 class="modal-title text-center">{{ 'unvalidatedBaskets.modal.title' | translate }}</h4>
  <i aria-label="Close" (click)="handleClick(CLOSE)" class="close pull-right align-middle fas fa-times"> </i>
</div>
<jhi-bary-icon icon="info" [faDirective]="FAS" size="3x" class="text-primary text-center m-2"></jhi-bary-icon>
<ul class="m-2">
  <li *ngFor="let message of messages" class="d-block w-100 mx-2 mb-1">
    {{ message }}
  </li>
</ul>
<div class="modal-footer justify-content-center flex-column">
  <jhi-bary-button class="btn bary-btn btn-primary" (clickEvent)="handleClick(CLOSE)" [label]="'BTN.CLOSE' | translate"></jhi-bary-button>
</div>
